<template>
  <div class="safety-assistant-layout safety-assistant">
    <div class="gradient-overlay"></div>
    <div class="gradient-blur gradient-blur-1"></div>
    <div class="gradient-blur gradient-blur-2"></div>

    <header class="safety-assistant-header">
      <h1 class="main-title">Safety Assistant</h1>
      <p class="powered-by">
        Powered by SALUS <span class="accent-color">IQ</span>
      </p>
    </header>

    <div class="content-wrapper">
      <div class="alternate-welcome-text">
        <p><b>Log in</b> or <b>create</b> a new SALUS account</p>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SafetyAssistantLayout',
}
</script>

<style scoped lang="sass">
.safety-assistant-layout
  position: relative
  min-height: 100vh
  overflow: hidden
  .gradient-overlay
    position: absolute
    inset: 0
    background: linear-gradient(to bottom right, $gradientBlue, transparent 50%, $gradientYellow)
    pointer-events: none
  .gradient-blur
    position: absolute
    width: 800px
    height: 800px
    border-radius: 50%
    filter: blur(120px)
    pointer-events: none
    &.gradient-blur-1
      top: -50%
      left: 25%
      background: $gradientBlueBlur
    &.gradient-blur-2
      bottom: -50%
      right: 25%
      background: $gradientYellowBlur

  .safety-assistant-header
    position: absolute
    top: 20px
    left: 40px
    align-items: flex-start
    display: flex
    flex-direction: column
    text-align: left
    z-index: 10
    @media (max-width: 768px)
      left: 16px
    .main-title
      font-family: 'Inter', sans-serif
      font-weight: 600
      font-size: 1.5625rem
      line-height: 1.2
      color: $white
      margin: 0
    .powered-by
      font-family: 'Inter', sans-serif
      color: $textLight
      font-size: 0.75rem
      margin: 2px 0 0 0
      display: flex
      align-items: center
      gap: 4px
      .accent-color
        color: $primaryBlue
        font-weight: 600

  .content-wrapper
    padding-top: 80px
    padding-bottom: 40px
    position: relative
    z-index: 1
    @media (max-width: 768px)
      padding-top: 120px
      padding-left: 16px
      padding-right: 16px
    ::v-deep .container.fill-height
      height: auto !important
      min-height: auto !important
      align-content: flex-start !important
    ::v-deep .v-row
      align-items: flex-start !important
      min-height: auto !important
    ::v-deep .terms-and-conditions
      margin-bottom: 0 !important
  .alternate-welcome-text
    text-align: center
    margin-bottom: 24px
    background: transparent !important
    p
      font-family: 'Inter', sans-serif
      font-size: 1.125rem
      color: $textLight
      margin: 0
      background: transparent !important
      b
        font-weight: 600
        color: $white
</style>
